export default "__VITE_ASSET__BZFigSg___"